import React, { Component } from 'react'
import config from '../../../config'
import { Card, Jumbotron, Col, Form, Button, Table } from 'react-bootstrap';
import errores from '../../../middleware/errordb';
import funciones from '../../../middleware/funciones';
import Mensajes from '../../subcomponent/mensajes'

import ModalConfirm from '../../subcomponent/modalConfirm';

export class tiposInventario extends Component {
    constructor(props) {
        super(props);

        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            evento: 1,
            fecha: todayFormat,
            codigo: "1",
            estado: "1",
            descripcion: "",
            mostrarMensaje: false,
            empresa: currentCompany,
            tipo: currentUserType,
            tiposInventario: [],
            mensaje: "",
            textButton: "Crear Tipo Inventario"
        }
    }

    componentDidMount() {
        this.infoTiposInv();
    }

    infoTiposInv = () => {
        const empresaEdicion = this.state.empresa;
        if (empresaEdicion) {
            const datasend = {
                method: 'GET',

                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/typeinventary/', datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const datos = data.data;
                        const tiposInventario = datos[0];
                        const codigo = datos[1][0]["LAST_COD"];
                        this.setState({
                            tiposInventario,
                            codigo,
                            controlCodigo: codigo
                        })
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: "Sin tipos creados" })
                    }
                });
        }
    }

    createtypeinventary = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        event.preventDefault();
        const { evento } = this.state
        const { codigo } = this.state
        const { descripcion } = this.state
        const { estado } = this.state
        const { empresa } = this.state

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA: empresa,
                CODIGO_TIPO_INV: codigo,
                DESCRIPCION_TIPO_INV: descripcion,
                ESTADO_TIPO_INV: estado
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': this.state.empresa
            }
        }
        let url = "";
        if (evento) {
            url = "/typeinventary/create/"
        } else {
            url = "/typeinventary/modify/"
        }
        fetch(config.servBackEnd + url, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.infoTiposInv();
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", descripcion: "", estado: "1", evento: 1, textButton: "Crear Tipo Inventario" });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Error en Tipo de inventario: " + errores[data.code] + " " + data.message })
                }
            });
    }

    edittype = (selected) => {
        this.setState({
            codigo: selected.CODIGO_TIPO_INV,
            descripcion: selected.DESCRIPCION_TIPO_INV,
            estado: selected.ESTADO_TIPO_INV,
            evento: 0,
            textButton: "Modificar Tipo Inventario"
        })
    }
    cleanForm = () => {
        const { controlCodigo } = this.state;
        this.setState({
            codigo: controlCodigo,
            descripcion: "",
            estado: "1",
            evento: 1,
            textButton: "Crear Tipo Inventario"
        })
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        const { tiposInventario } = this.state;
        const edittype = this.edittype;
        const mensajeConfirm = (this.state.evento) ? '¿Está seguro que desea crear el tipo de inventario?' : '¿Está seguro que desea modificar el tipo de inventario?';
        return (
            <div>

                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm}   ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>Tipo Inventarios</h2>
                </Jumbotron>
                <div>
                    <Card className="card">
                        <Card.Body>
                            <Form className="form" onSubmit={this.createtypeinventary}>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Codigo</Form.Label>
                                        <Form.Control type="text" value={this.state.codigo} required readOnly />
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Descripcion</Form.Label>
                                        <Form.Control type="text" onChange={e => this.setState({ descripcion: e.target.value.toUpperCase() })} value={this.state.descripcion} required />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="">
                                        <Form.Label>Tipo</Form.Label>
                                        <Form.Control as="select" onChange={e => this.setState({ estado: e.target.value })} value={this.state.estado} required >
                                            <option value="1">ACTIVO</option>
                                            <option value="0">INACTIVO</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                {!this.state.evento && <Button className="m-3" variant="primary" onClick={this.cleanForm}>Limpiar</Button>}
                                <Button className="m-3" variant="primary" type="submit">{this.state.textButton}</Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
                <div className="contenedor">
                    <Table hover bordered responsive size="sm" className="table">
                        <thead>
                            <tr>
                                <th>Empresa</th>
                                <th>Codigo</th>
                                <th>Descripcion</th>
                                <th>Estado</th>
                                <th colSpan="2">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tiposInventario.map(function (currentData, index) {
                                return <tr key={index + "d0"}>
                                    <td key={index + "d1"}>{currentData.ID_EMPRESA}</td>
                                    <td key={index + "d3"}>{currentData.CODIGO_TIPO_INV}</td>
                                    <td key={index + "d4"}>{currentData.DESCRIPCION_TIPO_INV}</td>
                                    <td key={index + "d5"}>{funciones.textEstadoGeneral(currentData.ESTADO_TIPO_INV)}</td>
                                    <td key={index + "d8"}><Button onClick={() => edittype(currentData)} variant="outline-primary">Editar</Button></td>
                                </tr>;
                            })}
                        </tbody>
                    </Table>
                </div>
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        )
    }
}

export default tiposInventario



// WEBPACK FOOTER //
// ./src/components/bussines/catalogos/tipoInventario.jsx